import {sessionStorageKeys as S} from '../constants/sessionStorageKeys';
import {getItemFromSessionStorage} from './sessionStorage';
import {setTokenHeader} from "../config/axios";
import config from '../config/common';

export const loadStore = () => {
    const locale = getItemFromSessionStorage(S.LOCALE);
    const regType = getItemFromSessionStorage(S.REG_TYPE);
    const token = getItemFromSessionStorage(S.TOKEN);
    if (token) setTokenHeader(token);

    return {
        locales: {current: locale || config.locale.default},
        regType: {regType: regType || config.regType.default}
    };
};
